// Catalogue partagé des pictos consignes / actes.
// CONTRAT extranet <-> mobile : la valeur stockée en base (champ `picto`) est le
// NOM MATERIAL ICON en PascalCase (ex. "VpnKey"), tel qu'exposé par
// @mui/icons-material ici et par androidx.compose.material.icons (extended) sur
// le mobile — même set, mêmes noms, aucune table de correspondance à maintenir.
// Ce catalogue ne sert qu'au sélecteur (liste finie + libellés FR). Une valeur
// hors catalogue reste rendue si c'est un nom Material valide ; fallback "Info".

export const PICTO_CATALOG = [
    { key: 'Route', label: 'Accès / itinéraire' },
    { key: 'Warning', label: 'Attention' },
    { key: 'Info', label: 'Information' },
    { key: 'VpnKey', label: 'Badge / digicode' },
    { key: 'Lock', label: 'Serrure / accès fermé' },
    { key: 'Place', label: 'Emplacement' },
    { key: 'Construction', label: 'Travaux' },
    { key: 'FormatColorFill', label: 'Graffiti / nettoyage' },
    { key: 'Build', label: 'Maintenance' },
    { key: 'Delete', label: 'Déchet / bac' },
    { key: 'LocalShipping', label: 'Véhicule / collecte' },
    { key: 'Opacity', label: 'Lavage' },
    { key: 'AccessTime', label: 'Horaire' },
    { key: 'CalendarMonth', label: 'Planning' },
    { key: 'Phone', label: 'Contact' },
    { key: 'MeetingRoom', label: 'Porte / local' },
    { key: 'Stairs', label: 'Escalier / niveau' },
    { key: 'LocalParking', label: 'Stationnement' },
    { key: 'Block', label: 'Interdit' },
    { key: 'Visibility', label: 'À vérifier' },
    { key: 'Flag', label: 'Point signalé' },
    { key: 'Star', label: 'Prioritaire' },
    { key: 'PhotoCamera', label: 'Photo requise' },
    { key: 'Description', label: 'Document' },
    { key: 'Security', label: 'Sécurité' },
    { key: 'Bolt', label: 'Électrique' },
    { key: 'Park', label: 'Espace vert' },
    { key: 'HomeRepairService', label: 'Réparation' },
    { key: 'Groups', label: 'Riverains / public' },
    { key: 'StickyNote2', label: 'Note' },
];

export const PICTO_FALLBACK = 'Info';

/** Entrée de catalogue pour un nom Material ; hors catalogue → entrée synthétique (le nom fait foi). */
export function getPicto(key) {
    const found = PICTO_CATALOG.find((p) => p.key === key);
    if (found) return {...found, mui: found.key};
    if (typeof key === 'string' && /^[A-Z][A-Za-z0-9]*$/.test(key)) return {key, label: key, mui: key};
    const fallback = PICTO_CATALOG.find((p) => p.key === PICTO_FALLBACK);
    return {...fallback, mui: fallback.key};
}
